import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.68 6.625a.82.82 0 0 1 .549-.366.76.76 0 0 1 .617.178l6.16 5.249 6.16-5.249a.76.76 0 0 1 .617-.178.82.82 0 0 1 .548.366 1 1 0 0 1 .147.333 1.05 1.05 0 0 1-.09.723.9.9 0 0 1-.223.275l-6.51 5.548a1 1 0 0 1-.65.246 1 1 0 0 1-.648-.246l-6.51-5.548a.9.9 0 0 1-.223-.275 1.052 1.052 0 0 1-.09-.722 1 1 0 0 1 .146-.334",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }